export default __webpack_public_path__ + "static/part1_1mb-88d302537b20593e4c7b5450a33f57c2.png";